import { createHOC } from 'vue-hoc';
import { flowRight as compose } from 'lodash';
import queries from '~lib/common/queries/Medication';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';

import MedicationsOnAtStartPanel from './MedicationsOnAtStartPanel.vue';

const options = {
  name: 'SideNavContainer',
  props: {
    navigation: {
      type: Object,
      default: () => null,
    }
  }
};

const renderWith = {
  props: {
    navigation() {
      return this.navigation;
    }
  }
};

const MOATContainer = createHOC(MedicationsOnAtStartPanel, options, renderWith);
export default compose(
  dataView({
    queries: {
      fetch: queries.fetch,
    },
  }),
  renameProps({ data: 'medications' }),
)(MOATContainer);
